<app-tree-table
  [(selection)]="selection"
  (focusDateChange)="focusDateChange($event)"
  (selectionChange)="selectionChange($event)"
  [actionColumnWidth]="450"
  [columns]="columns"
  [firstColumnFrozen]="true"
  [focusDate]="focusDate"
  [focusLabelKey]="'VARIABLES.FOCUS'"
  [hasFocusDate]="true"
  [hierarchyLevels]="hierarchyLevels"
  [loading]="loading"
  [pagination]="false"
  [selectable]="true"
  [value]="value"
  dataKey="tacsId">
  <ng-template
    (onClick)="showDialog($event.row)"
    appActionButton
    displayIfNot="node.data.fake"
    icon="fal fa-search"
    labelKey="GLOBAL.DETAILS"></ng-template>

  @if (isManager()) {
    <ng-template
      (onClick)="newBetriebsVariable($event.row)"
      appActionButton
      displayIf="node.data.canAddBetriebsVariable"
      icon="fal fa-plus"
      labelKey="VARIABLES.NEW_BETRIEBSVARIABLE"></ng-template>
  }

  @if (isManager()) {
    <ng-template
      (onClick)="measuresMenu.show($event)"
      [labelKey]="'GLOBAL.MEASURES'"
      appToolbarButton
      icon="fal fa-hand-holding-medical"></ng-template>
  }

  @if (isManager()) {
    <ng-template
      (onClick)="showDeactivate()"
      [disabled]="!deactivateEnabled"
      appToolbarButton
      icon="fal fa-stop-circle"
      labelKey="VARIABLES.DEACTIVATE_SELECTED"></ng-template>
  }

  @if (isManager()) {
    <ng-template
      (onClick)="showActivate()"
      [disabled]="!activateEnabled"
      appToolbarButton
      icon="fal fa-play-circle"
      labelKey="VARIABLES.ACTIVATE_SELECTED"></ng-template>
  }
</app-tree-table>

<p-tieredMenu
  (click)="measuresMenu.hide()"
  [hideTransitionOptions]="'0ms'"
  [model]="viewMenuModel"
  [popup]="true"
  [showTransitionOptions]="'0ms'"
  [style]="{ width: '300px' }"
  #measuresMenu></p-tieredMenu>
